import '@fontsource-variable/inter';
import '@fontsource/ibm-plex-mono/400.css';
import '@fontsource/ibm-plex-mono/500.css';
import '@fontsource/ibm-plex-mono/600.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.js';
import { isPlatformRoute, PublicSite } from './components/PublicSite.js';
import { applyDocumentLanguage, LanguageProvider, resolveLanguagePreference } from './i18n/context.js';
import './styles.css';

const root = document.getElementById('root');
if (!root) throw new Error('Root mount #root not found.');
const platformRoute = isPlatformRoute();
if (platformRoute) applyDocumentLanguage(document, resolveLanguagePreference(window.localStorage));

createRoot(root).render(
  <StrictMode>
    {platformRoute ? <LanguageProvider><App /></LanguageProvider> : <PublicSite />}
  </StrictMode>
);
